export const MERGE_CONFIDENCE = [
  'low',
  'neutral',
  'high',
  'very high',
] as const;
